export default __webpack_public_path__ + "static/media/person_1.52e12841.png";